// extracted by mini-css-extract-plugin
export default {"feedbackContainer":"h5-z","upvoteIcon":"i5-z","downvoteIcon":"j5-z","feedbackIcon":"k5-z"};